import { gql, useQuery } from "urql";
import type { TypedDocumentNode } from "urql";
import { type CorporateGroupEnvelope, firstCorporateGroup } from "./corporateGroupEnvelope";

export interface CorporateGroupSummary {
  id: string;
  name: string | null;
  externalReference: string | null;
  memberCount: number;
}

type CorporateGroupSummaryQueryData = CorporateGroupEnvelope<CorporateGroupSummary>;

interface CorporateGroupSummaryQueryVariables {
  id: string;
}

const CorporateGroupSummaryQuery: TypedDocumentNode<
  CorporateGroupSummaryQueryData,
  CorporateGroupSummaryQueryVariables
> = gql`
  query GetCorporateGroupSummary($id: ID!) {
    clients(first: 1, filter: { id: $id }) {
      edges {
        node {
          id
          corporateGroup {
            id
            name
            externalReference
            memberCount
          }
        }
      }
    }
  }
`;

export interface CorporateGroupSummaryResult {
  group: CorporateGroupSummary | undefined;
  isPending: boolean;
}

export function useCorporateGroupSummary(clientId: string | undefined): CorporateGroupSummaryResult {
  const [result] = useQuery({
    query: CorporateGroupSummaryQuery,
    variables: { id: clientId ?? "" },
    requestPolicy: "cache-first",
    pause: !clientId,
  });

  return {
    group: firstCorporateGroup(result.data),
    isPending: result.fetching || result.stale,
  };
}
